import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';

const ContractsHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>Search Options</textblocks.Heading3>

        <p>
            In DocuSign Analyzer you can choose to search by either using the limited&nbsp;<i>
                filename searching
            </i>
            or <i>Advanced searching.</i>
            The latter option is more powerful since you can be more specific in what you&apos;re
            looking for in your contracts. Below you can find some help when it comes to writing{' '}
            <i>advanced search queries.</i>
        </p>

        <p>
            Important to note is that searching based on the <b>OR</b> operator by default, which
            means the more <i>search terms</i> you add, the wider the result will be.
        </p>

        <textblocks.Heading3>Search Operators</textblocks.Heading3>
        <textblocks.Heading4>General</textblocks.Heading4>
        <dl>
            <dt>+</dt>
            <dd>Require this term in the result.</dd>
            <dt>-</dt>
            <dd>Exclude this term from the result.</dd>
            <dt>*</dt>
            <dd>Wildcard search.</dd>
            <dt>?</dt>
            <dd>Wildcard, single character.</dd>
            <dt>␣</dt>
            <dd>Space is equivalent to OR (boolean operator).</dd>
        </dl>

        <textblocks.Heading4>Grouping</textblocks.Heading4>
        <dl>
            <dt>&quot; &quot;</dt>
            <dd>
                Group words to search for an exact phrase.<br />Note: Wildcards do not work inside
                quotes.
            </dd>
            <dt>( )</dt>
            <dd>Group multiple search terms.</dd>
        </dl>

        <textblocks.Heading3>Download Link</textblocks.Heading3>
        <p>
            When clicking the button a one time link to the document will be copied to clipboard.
            Paste the link in a browser address bar to download the document. The link is a personal
            one time link that will expire after 4 hours.
        </p>
    </HelpModalContentBody>
);

export default ContractsHelpModalContent;
